import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import {
  Item,
  Title,
  Subtitle,
  Price,
  IconWrapper,
  Counter,
  Summary,
  Publications,
  Description,
  IconTrash,
  TabItem,
  Subtotal,
  Day,
  Content
} from './styled';
import {
  PublicationModel,
  deletePrintAllByChannel,
  clearExtracharge,
  clearPhotoVignette,
} from '@app/src/views/StepTwo/channelPublication';
import { deleteAllDateSelected } from '@app/src/common/datePicker/state/calendar/actions';
import { isClientEnv } from '@app/src/utils/validations';
import { CATEGORY, CATEGORIES } from '@app/src/config/categories';
import { configCalendarId } from '@app/src/views/StepTwo/channelPublication/components/ChannelsPublication/constants';

interface Props {
  title?: string;
  day?: string;
  priceIgv?: number;
  details?: PublicationModel[];
  idNewspaper?: number;
  handleClickItem?: Function;
  priceSubTotal?: string;
  extrachargeSelected?: any;
}

const isClient = isClientEnv();

export const OptionChannelSummary: React.FC<Props> = ({
  title,
  day,
  priceIgv,
  details,
  idNewspaper,
  handleClickItem,
  priceSubTotal,
  // extrachargeSelected
}) => {
  const [ open, setOpen ] = useState(false);
  const dispatch = useDispatch();
  const publicationLabel = details && details.length == 1 ? 'Publicación' : 'Publicaciones';
  const printsByChannel = useSelector(state => state.print.printsByChannel);
  const print = useSelector(state => state.print);
  const category = useSelector(state => state.print.general.category);
  const categoryTheme = CATEGORIES[CATEGORY[category]];

  const handleClickOpen = () => {
    handleClickItem && handleClickItem();
    setOpen(!open);
  };

  const handleClickDelete = useCallback(() => {
    const isDiscard = confirm('Todos los cambios se borrarán, ¿desea seguir con la acción?');
    if (isDiscard) {
      const packages = Object.values(configCalendarId);
      packages.map(channel => {
        if (channel.groupId === idNewspaper) {
          dispatch(deletePrintAllByChannel(channel.id));
          dispatch(clearPhotoVignette(channel.id));
          dispatch(deleteAllDateSelected(channel.id));
          dispatch(clearExtracharge(channel.id));
        }
      })
      isClient && sessionStorage.setItem('print', JSON.stringify(print));
    }
  }, [printsByChannel]);

  return(
    <Item>
      <TabItem onClick={handleClickOpen}>
        <Title>{`Clasificados ${title}`}{day && <Day> - {day}</Day>}</Title>
        <Subtitle>Precio por publicación desde <Price>{`S/ ${priceIgv}`}</Price></Subtitle>
        <IconWrapper>
            {details && details.length > 0 && <Counter color={categoryTheme && categoryTheme.color}>{details.length}</Counter>}
            <Icon data-name="icon-expand-more" fill={COLORS.GRAY_PLACEHOLDER} width="9" height="9" />
        </IconWrapper>
      </TabItem>
      {
        details && details.length > 0 &&
        <Summary>
          <Publications>{details.length} {publicationLabel}</Publications>
          <Content>
          {details && details.map((item, index) => (
            <Description key={index}>{item.dateFormat}</Description>
          ))}
          </Content>
          {/* {
            extrachargeSelected && extrachargeSelected.length > 0 &&
            <React.Fragment>
              <Publications>Extracargos</Publications>
              <Content>
                {
                  extrachargeSelected.map((item, index) => (
                    <Description key={index}>{item.name} x {details.length}</Description>
                  ))
                }
              </Content>
            </React.Fragment>
          } */}
          <Subtotal>Sub Total S/ {priceSubTotal}</Subtotal>
          <IconTrash onClick={handleClickDelete}>
              <Icon data-name="icon-trash" fill={COLORS.GRAY_DARK} width ="16" height="16" />
          </IconTrash>
        </Summary>
      }
    </Item>
)};
